export const grid = {
  colCount: 16,
  gap: {
    min: 8,
    max: 20,
  },
};
